import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Lightbox from 'react-image-lightbox';
import HeaderFive from '../../components/Header/HeaderFive';
import FooterThree from '../../components/Footer/FooterThree';
import Breadcrumb from '../../components/Breadcrumb';
import 'react-image-lightbox/style.css';

const GalleryPage = () => {
  const [images, setImages] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const imagesPerPage = 12;

useEffect(() => {
  axios.get('https://ricgop.online/api/get-archives.php')
    .then(res => {
      const data = Array.isArray(res.data.archives) ? res.data.archives : [];

      const galleryImages = data.map(item => {
        const dateObj = new Date(item.archive_date);
        const year = dateObj.getFullYear();
        const month = dateObj.toLocaleString('default', { month: 'short' });
        const day = dateObj.getDate();
        const formatted = `${day} ${month}, ${year}`;

        return {
          src: `/assets/img/archive/${year}/${item.image_path}`,
          title: item.title,
          year,
          date: formatted,
          rawDate: dateObj
        };
      });

      setImages(galleryImages);

      // Count per year
      const yearCounts = galleryImages.reduce((acc, img) => {
        acc[img.year] = (acc[img.year] || 0) + 1;
        return acc;
      }, {});

      const uniqueYears = Object.keys(yearCounts)
        .map(year => ({ year: parseInt(year), count: yearCounts[year] }))
        .sort((a, b) => b.year - a.year);

      setYears(uniqueYears);
    })
    .catch(err => console.error('Error fetching gallery images:', err));
}, []);


  useEffect(() => {
    let data = images;

    if (selectedYear) {
      data = data.filter(img => img.year === parseInt(selectedYear));
    }

    if (searchTerm.trim() !== '') {
      data = data.filter(img =>
        img.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFiltered(data);
    setCurrentPage(1); // Reset to page 1 when filters change
  }, [selectedYear, searchTerm, images]);

  const paginatedImages = filtered.slice(
    (currentPage - 1) * imagesPerPage,
    currentPage * imagesPerPage
  );

  const totalPages = Math.ceil(filtered.length / imagesPerPage);

  const openLightbox = (index) => {
    setCurrentIndex(index + (currentPage - 1) * imagesPerPage);
    setLightboxOpen(true);
  };

  const downloadImage = (src, title) => {
    const link = document.createElement('a');
    link.href = src;
    link.download = title.replace(/\s+/g, '_');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="gallery-wrapper">
      <HeaderFive />
      <Breadcrumb title="Gallery" />

      <main className="gallery-section container py-5">
        <h2 className="text-center mb-4 gallery-title">📷 Our Gallery</h2>

        <div className="filter-bar row g-3 align-items-center mb-4">
          <div className="col-md-4">
           <select
                className="form-control filter-input"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                >
                <option value="">📅 Filter by Year</option>
                {years.map(({ year, count }) => (
                    <option key={year} value={year}>
                    {year} ({count})
                    </option>
                ))}
                </select>

          </div>
          <div className="col-md-8">
            <input
              type="text"
              className="form-control filter-input"
              placeholder="🔍 Search by title..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="gallery-grid">
          {paginatedImages.map((img, index) => (
            <div className="gallery-card" key={index}>
              <div className="gallery-image-wrapper" onClick={() => openLightbox(index)}>
                <img src={img.src} alt={img.title} className="gallery-img" />
                <div className="gallery-overlay">
                  <div className="overlay-text">
                    <h5>{img.title}</h5>
                    <p>{img.date}</p>
                  </div>
                </div>
              </div>
              <div className="download-btn">
                <button className="btn btn-download" onClick={() => downloadImage(img.src, img.title)}>
                  ⬇ Download
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination-bar mt-4 text-center">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}
          </div>
        )}
      </main>

      <FooterThree />

      {lightboxOpen && (
        <Lightbox
          mainSrc={filtered[currentIndex].src}
          nextSrc={filtered[(currentIndex + 1) % filtered.length]?.src}
          prevSrc={filtered[(currentIndex + filtered.length - 1) % filtered.length]?.src}
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() => setCurrentIndex((currentIndex + filtered.length - 1) % filtered.length)}
          onMoveNextRequest={() => setCurrentIndex((currentIndex + 1) % filtered.length)}
          imageTitle={filtered[currentIndex].title}
          imageCaption={filtered[currentIndex].date}
        />
      )}

      {/* CSS in same file */}
      <style>{`
        .gallery-wrapper {
          background: #f8fbff;
          font-family: 'Segoe UI', sans-serif;
        }

        .gallery-title {
          font-size: 2.3rem;
          color: #0d6efd;
          font-weight: 600;
        }

        .filter-bar .filter-input {
          height: 46px;
          border-radius: 8px;
        }

        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 25px;
        }

        .gallery-card {
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 12px 30px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
        }

        .gallery-card:hover {
          transform: translateY(-6px);
        }

        .gallery-image-wrapper {
          position: relative;
          cursor: pointer;
        }

        .gallery-img {
          width: 100%;
          height: 220px;
          object-fit: cover;
          transition: transform 0.4s ease;
        }

        .gallery-image-wrapper:hover .gallery-img {
          transform: scale(1.05);
        }

        .gallery-overlay {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(to top, rgba(13,110,253,0.85), transparent);
          opacity: 0;
          transition: opacity 0.4s ease;
          display: flex;
          align-items: flex-end;
          padding: 15px;
        }

        .gallery-image-wrapper:hover .gallery-overlay {
          opacity: 1;
        }

        .overlay-text h5 {
          color: #fff;
          font-size: 1rem;
          margin-bottom: 4px;
        }

        .overlay-text p {
          color: #f8f9fa;
          font-size: 0.85rem;
          margin: 0;
        }

        .download-btn {
          padding: 10px 15px;
          border-top: 1px solid #eee;
          background-color: #f9f9f9;
        }

        .btn-download {
          background-color: #0d6efd;
          color: white;
          width: 100%;
          border: none;
          border-radius: 5px;
          padding: 6px 12px;
          font-size: 0.9rem;
          transition: background-color 0.3s ease;
        }

        .btn-download:hover {
          background-color: #084298;
        }

        .pagination-bar {
          display: flex;
          justify-content: center;
          gap: 10px;
        }

        .page-btn {
          background: #e9ecef;
          border: none;
          padding: 8px 14px;
          border-radius: 6px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.3s;
        }

        .page-btn:hover {
          background: #0d6efd;
          color: white;
        }

        .page-btn.active {
          background: #0d6efd;
          color: white;
        }

        @media (max-width: 576px) {
          .gallery-img {
            height: 160px;
          }
        }
      `}</style>
    </div>
  );
};

export default GalleryPage;
